/**
 * Client-side feature flag definitions.
 * Update these values (and document the change in docs/FEATURE_FLAGS.md)
 * whenever a capability should be toggled on/off without removing code paths.
 */
export type FeatureFlag =
  | "creditSystem"
  | "designStudioV1"
  | "vendorApplicationsStandalone";

export const FEATURE_FLAGS: Record<FeatureFlag, boolean> = {
  /**
   * End-to-end credit dashboards for buyers and suppliers.
   * Default off until credit ledger + payouts are production ready.
   */
  creditSystem: false,
  /**
   * Legacy Design Studio V1 experience (full canvas editor + 3D preview).
   * Keep disabled while Mockup Studio remains the default.
   */
  designStudioV1: false,
  /**
   * Dedicated vendor application review surface at /admin/vendor-applications.
   * Enabled by default to keep the queue discoverable in navigation.
   */
  vendorApplicationsStandalone: true,
};

export const isFeatureEnabled = (flag: FeatureFlag) => FEATURE_FLAGS[flag];

